export default __webpack_public_path__ + "img/homepage.commitment.01.asset.5fef315e.jpg";